module.exports = __webpack_public_path__ + "img/Crayon-de-modification.eba44384.svg";